// @flow
import React, { Component } from 'react';

import Breadcrumb from 'components/fragments/Breadcrumb';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import SideBillboardCard from 'components/billboard/SideBillboardCard';
import Sidebar from 'components/sidebar/Sidebar';
import BackgroundImage from 'containers/fragments/BackgroundImageContainer';
import LiveScore from 'containers/fragments/LiveScoreContainer';

import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';
import type { ArticleType } from 'types/Article';

type Props = {
  title: string,
  featured_media: {
    src: string,
    legend: string,
  },
  excerpt: string,
  meta_description: string,
  status: Status,
  description: BlocContent[],
  sidebar: BlocContent[],
  banniere: string,
  match: {
    params: {
      slug: string,
    }
  },
  pageSlug: string,
  rencontresLive: number
};

type State = {
  partnersNews: ArticleType[],
};

class PageListNode extends Component<Props, State> {
  state = {
    partnersNews : [],
  };

  componentDidMount() {
    if (window.location.hash) {
      setTimeout(() => {
        const element = document.getElementById(window.location.hash.substr(1));
        if (element) {
          element.scrollIntoView();
        }
      }, 500);
    }
  }

  renderBlocContent = () => {
  const { description } = this.props;
    return description.map<any>((blocProps, index) =>
      (
        <ContentBloc key={index} {...blocProps} />
      )
    );
  };

  renderPartnerNews = (): React$Element<'div'>[] | null => {
    const { partnersNews } = this.state;
    if (partnersNews.length) {
      return partnersNews.map((news: ArticleType): React$Element<'div'> => (
        <div key={`actu-partenaire-${news.slug}`} className="col col-md-6 col-lg-4">
          <SideBillboardCard content={news} />
        </div>
      ));
    }
    return null;
  };

  render() {
    const { renderBlocContent } = this;
    const {
      featured_media,
      title,
      excerpt,
      sidebar,
      banniere,
      rencontresLive,
    } = this.props;

    let bannerClass = "banner";
    if (rencontresLive) {
      bannerClass = "banner banner--live-score";
    }

    return (
      <>
        <section className={bannerClass}>
          <BackgroundImage
            className="banner__thumbnail img-blue-dark"
            illustration={featured_media.src || banniere}
            baliseImg={false}
          />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title}</h1>
            {excerpt &&
            <p className="banner__desc">
              {excerpt}
            </p>}
          </div>
          <LiveScore />
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <div className="col col-lg-8on9">
                <div className="page mt-2 mt-md-0">
                  {renderBlocContent()}
                </div>
              </div>
            </div>
            <Sidebar sidebarContent={sidebar} />
          </div>
        </div>
      </>
    );
  }
}

export default PageListNode;
